@use "@fukuri-admins/ui/layout" as *;

.alertDialog {
  position: fixed;
  z-index: 99998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  overflow-y: scroll;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  margin: 0;
  max-width: none;
  max-height: none;

  &::backdrop {
    background-color: rgba(0, 0, 0, 0.7);
  }
}

.modalRoot {
  padding: spacing("24");
  box-sizing: border-box;
  width: 100%;
  max-width: 512px;
  height: fit-content;
  background: #fff;
  border-radius: borderRadius("xl");
  margin: auto;
  @include elevation("3");
}

.title {
  @include typography("Jp/16_W6");
  color: text("High");

  @media #{breakPoints('sm')} {
    text-align: center;
  }
}

.descContainer {
  color: text("Low");
  @include typography("Jp/14_W3");
  margin-top: spacing("8");

  @media #{breakPoints('sm')} {
    text-align: center;
  }
}

.btnContainer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: spacing("8");
  margin-top: spacing("16");

  @media #{breakPoints('sm')} {
    flex-direction: column-reverse;

    button {
      width: 100%;
    }
  }
}
